<template>
	<div v-if="externalAdsLoading === false" class="external-ad-list">
		<external-ad v-for="ad in externalAds" :key="ad.id" :ad="ad" :height="imageHeight"/>
	</div>
</template>

<script>
	import ExternalAd from '@/components/ExternalAd.vue'

	import { mapState } from 'vuex'

	export default {
		name: "ExternalAdList",
		components: {
			ExternalAd
		},
		data() {
			return {
				imageHeight: 0
			}
		},
		computed: {
    	...mapState(["externalAdsLoading", "externalAds"]),
		},
		methods: {
			handleWindowResize() {
				let height = window.innerHeight;
				this.imageHeight = Math.min(300, height / 2);
			}
		},
		created() {
			if (this.externalAdsLoading == null) {
				this.$store.dispatch("loadExternalAds");
			}
		},
		mounted() {
			this.handleWindowResize();
			this.$nextTick(() => {
				window.addEventListener('resize', this.handleWindowResize);
			});
			this.$once('hook:beforeDestroy', () => window.removeEventListener('resize', this.handleWindowResize));
		}
	}
</script>

<style lang="scss">
	.external-ad-list {
		margin-bottom: 1rem;
		margin-bottom: 0.75rem;
		overflow-x: auto;
		overflow-y: hidden;
		white-space: nowrap;
		-webkit-overflow-scrolling: touch;
	}
</style>